import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from '../i18n/LocaleContext';

const ProductDetailModal = ({ isOpen, onClose, product }) => {
  const { t } = useTranslation();
  if (!isOpen || !product) return null;

  const formatCurrency = (amount) => {
    const value = amount || 0;
    const isWholeNumber = value % 1 === 0;
    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: isWholeNumber ? 0 : 2,
      maximumFractionDigits: isWholeNumber ? 0 : 2
    }).format(value);
    return `$${formatted}`;
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-xl shadow-lift w-full max-w-md overflow-hidden">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h3 className="text-xl font-bold text-ink pr-4">{product.productName}</h3>
            <button onClick={onClose} className="p-1 -m-1 rounded-full text-ink-muted hover:bg-canvas hover:text-ink transition-colors flex-shrink-0">
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="w-full h-64 bg-canvas rounded-xl mb-4 flex items-center justify-center overflow-hidden">
            <img
              src={product.productImage}
              alt={product.productName}
              className="max-w-full max-h-full object-contain"
              onError={(e) => {
                e.target.src = '/images/placeholder.svg';
              }}
            />
          </div>

          <div className="bg-canvas rounded-xl p-4 mb-6 flex justify-between items-center">
            <span className="text-ink-secondary">{t('price')}:</span>
            <span className="text-ink font-extrabold text-lg tabular-nums">{formatCurrency(product.price)}</span>
          </div>

          <button
            onClick={onClose}
            className="w-full h-12 rounded-full bg-canvas text-ink font-bold hover:bg-gray-200 transition-colors"
          >
            {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailModal;
